// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { ContactLensEyeRequest } from './contact-lens-eye-request';

/** See com.rev360.pms.api.controller.encounter.contactlens.UpdateContactLensTrialRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdateContactLensTrialRequest extends GandalfModelBase {

	@GandalfLabel('Comments')
	@GandalfValidator({ sizeString: { message: 'Comments cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	commentsOd!: string | null;

	@GandalfLabel('Comments')
	@GandalfValidator({ sizeString: { message: 'Comments cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	commentsOs!: string | null;

	@GandalfLabel('Dispensed')
	@GandalfProperty({ designType: Boolean })
	dispensedOd!: boolean | null;

	@GandalfLabel('Dispensed')
	@GandalfProperty({ designType: Boolean })
	dispensedOs!: boolean | null;

	@GandalfLabel('Encounter')
	@GandalfProperty({ designType: Number })
	encounterId!: number | null;

	@GandalfValidator({ notNull: { message: 'Contact Lens Trial is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	id!: number;

	@GandalfLabel('Od')
	@GandalfProperty({ designType: ContactLensEyeRequest })
	od!: ContactLensEyeRequest | null;

	@GandalfLabel('Os')
	@GandalfProperty({ designType: ContactLensEyeRequest })
	os!: ContactLensEyeRequest | null;

	@GandalfConstantDecorator(constants.ContactLensPrescriptionType)
	@GandalfLabel('Lens Type')
	@GandalfValidator({ notNull: { message: 'Lens Type is required' } })
	@GandalfProperty({ designType: constants.ContactLensPrescriptionType, isRequired: true })
	overallLensType!: constants.ContactLensPrescriptionType;

	@GandalfLabel('OD Model name')
	@GandalfValidator({ notNull: { message: 'OD Model name is required' } })
	@GandalfValidator({ sizeString: { message: 'OD Model name must be between 1 and 100 characters', minLength: 1, maxLength: 100 } })
	@GandalfProperty({ designType: String, isRequired: true })
	productOdName!: string;

	@GandalfLabel('OS Model name')
	@GandalfValidator({ notNull: { message: 'OS Model name is required' } })
	@GandalfValidator({ sizeString: { message: 'OS Model name must be between 1 and 100 characters', minLength: 1, maxLength: 100 } })
	@GandalfProperty({ designType: String, isRequired: true })
	productOsName!: string;

}
